import api from '.'

export const getAppToken = async (idToken: string) => {
  const res = await api.post('/v1/auth/token', {
    idToken,
  })
  return res.data
}
